<template>
  <div class="container">
   <div class="main" v-loading="loading">
    <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{ $t('applyChild.detail') }}</span>
        </div>
        <div class="right">
          <el-button class="back-btn" icon="el-icon-back" @click="returnBack">{{$t('applyChildDetail.return')}}</el-button>
        </div>
    </div>
    <div class="detail-box">
        <div class="top">
            <div class="user-info">
                <div class="avatar">
                  <img :src="dataSource.createUserAvatar" alt="" v-if="dataSource.createUserAvatar" />
                  <img src="@/assets/img/avatar.png" alt="" v-else />
                </div> 
                <div class="info-box">
                    <div class="name">{{ dataSource.createUserName }}</div>
                    <div class="creatime">{{ dataSource.createTime }}</div>
                </div>
            </div>
            <!-- <div class="btns" >
                <el-button class="edit-btn" @click="toEdit">编辑</el-button>
                <el-button class="delete-btn" @click="deleteItem">删除</el-button>
            </div> -->
        </div>
        <div class="content">
            <div class="topic">
                <i class="el-icon-collection-tag title-icon"></i>
                <p class="title">{{ dataSource.alarmType }}</p>
            </div>
            <div class="entires">
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('faultDetail.solveProgramme')}}</div>
                    <div class="con">{{ dataSource.solution }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('componentsReply.enclosure')}}</div>
                    <div class="con">
                        <div class="attach-list">
                             <div class="list-item" 
                             v-for="(item, index) in attachMent"
                             :key="index"
                             @click="downloadFile(item)"
                             >
                                <div class="type">
                                    <img :src="item.resource" alt="" />
                                </div>
                                <div class="file-info">
                                    <span class="name">{{ item.name }}</span>
                                    <span class="size">{{ item.size }}</span>
                                </div>
                             </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('componentsReply.image')}}</div>
                    <div class="con-1">
                        <div class="image" 
                        v-for="(img, index) in dataSource.photo ? dataSource.photo.split(',') : []"
                        :key="index"
                        >
                            <el-image 
                                style="width: 100px; height: 100px"
                                :src="img" 
                                :preview-src-list="[img]">
                            </el-image>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="label">{{$t('faultFilter.associatedProduct')}}</div>
                    <div class="con">
                        <div class="related-list">
                            <div class="related-item" 
                            v-for="(product, idx) in dataSource.productList"
                            :key="idx"
                            >
                                <span class="name">{{ product.name }}</span>
                                <p class="args">【<span>{{$t('applyChild.code')}}：{{ product.code }};</span><span>{{$t('applyChild.model')}}：{{ product.model }};</span><span>{{$t('applyChild.size')}}：{{ product.specification }}</span>】</p>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
   </div>
  </div>
</template>

<script>
import { commonDetail, tempDetail, deleteCommonItem, deleteTempItem } from "@/api/fault"
import { onfileResourceChange, matchFileType, formatByte } from "@/util/fileType"
  export default {
    data() {
      return {
        detailApi: null,
        deleteApi: null,
        dataSource: [],
        attachMent: [],
        loading: false
      }
    },
    computed: {
      id() {
        if(this.$route.query && this.$route.query.id) {
            return this.$route.query.id
        }
      },
      type() {
        if(this.$route.meta && this.$route.meta.type) {
            return this.$route.meta.type
        }
      }
    },
    created() {
       this.getDetail();
    },
    methods: {
      handleDetailApiChange(e) {
        switch(e) {
          case 'common':
            return commonDetail;
          case 'temp':
            return tempDetail;
        }
      },
      handleDeleteApiChange(e) {
        switch(e) {
          case 'common':
            return deleteCommonItem;
          case 'temp':
            return deleteTempItem;
        }
      },
      handleRouterNameChange(e) {
        switch(e) {
          case 'common':
            return 'alarmCommonExplain';
          case 'temp':
            return 'alarmTempExplain';
        }
      },
      toEdit() {
        this.$router.push({
          path: `/service/${this.handleRouterNameChange(this.type)}-edit`,
          query: {
            id: this.id
          }
        })
      },
      deleteItem() {
        let self = this;
        self.$confirm(this.$t('faultDetail.sureDelete'), this.$t('lockIndex.tip'), {
          confirmButtonText: this.$t('indexTags.sure'),
          cancelButtonText: this.$t('indexTags.cancel'),
          type: 'warning'
        }).then( async() => {
          self.loading = true;
          self.deleteApi = self.handleDeleteApiChange(self.type);
          let { data } = await self.deleteApi(self.id);
          if(data && data.code === 200) {
            self.$message({
              type: 'success',
              message: this.$t('shoppingChild.deleteSuc')+'！'
            });
            setTimeout(() => {
              self.returnBack()
            },1000)
          }
           self.loading = false;
        }).catch(() => {
          self.$message({
            type: 'info',
            message: this.$t('faultDetail.cancelDelete')
          });
        });
      },
      attachmentFormatter(arr, arr1, arr2) {
       
        let nameList = arr && arr.split(",");
        let urlList = arr1 && arr1.split(",");
        let sizeList = arr2 && arr2.split(",");
        if(nameList.length && urlList.length) {
            let newArr = []
            urlList.map((x, idx) => {
                newArr.push({
                    name: nameList[idx],
                    url: x,
                    resource: onfileResourceChange(matchFileType(nameList[idx])),
                    size: formatByte(sizeList[idx]?sizeList[idx]:'')
                })
            })
            return newArr;
        }
        console.log('this.explainList', this.explainList);
      },
      returnBack() {
         this.$EvenBus.$emit('menuTag', this.$route.fullPath, 'remove');
      },
      // 下载附件
      downloadFile(item) {
      
        console.log('item', item)
        if(!item.url || item.url === 'null') {
            this.$message.error(this.$t('complaintOrderDetail.noEnclosureAddress'));
            return;
        }
        const url = item.url;
        window.open(url);
      },
      async getDetail() {
        try {
          this.loading = true;
          this.detailApi = this.handleDetailApiChange(this.type);
          const res = await this.detailApi(this.id);
          console.log('res =>', res.data);
          if(res.data && res.data.code === 200) {
              this.dataSource = res.data.data;
              this.attachMent = this.attachmentFormatter(res.data.data.attachName ? res.data.data.attachName : '', 
              res.data.data.attach ? res.data.data.attach : '', 
              res.data.data.attachSize ? res.data.data.attachSize : '')
          }
          this.loading = false;
        } catch(e) {
          this.$message.error(e.toString());
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}
.main {
  background-color: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    .left {
      display: flex;
      align-items: center;
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01AAA7;
        border-radius: 2px;
      }
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01AAA7;
        border-radius: 1px;
      }
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      .back-btn {
        background-color: #01AAA7;
        color: #fff;
      }
    }
  }
  .detail-box {
    padding: 20px 21px;
    .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .user-info {
            display: flex;
            align-items: center;
            .avatar {
                width: 28px;
                height: 28px;
                & > img {
                    width: 100%;
                    height: 100%;
                }
            }
            .info-box {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin-left: 14px;
                .name {
                    font-size: 12px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                }
                .creatime {
                    font-size: 12px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }
        .edit-btn {
            border-color: #50C4CB;
            color: #50C4CB;
        }
        .delete-btn {
            border-color: #E24329;
            color: #E24329;
        }
    }
    .content {
        margin-top: 20px;
        border: 1px solid #E5E5E5;
        .topic {
            display: flex;
            align-items: center;
            padding: 23px 30px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            background-color: #F4F5FA;
            .title-icon {
                color: #50C4CB;
            }
            .title {
                color: #333333;
                margin-left: 12px;
            }
        }
        .entires {
            padding: 20px 95px;
          .row {
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #EEEEEE;;
          }
          .label {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            min-height: 20%;
          }
          .con {
            margin-left: 30px;
            flex: 1;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
          .col {
            display: flex;
            align-items: center;
          }
          .con-1 {
            display: flex;
            align-items: center;
            margin-left: 30px;
            flex: 1;
          }
          .attach-list {
            .list-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .type {
                    width: 26px;
                    height: 32px;
                    & > img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .file-info {
                    margin-left: 9px;
                    display: flex;
                    flex-direction: column;
                    .name {
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #333333;
                    }
                    .name:hover {
                        text-decoration: underline;
                        color: #1E90FF;
                    }
                    .size {
                        font-size: 12px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
            .list-item:hover {
              cursor: pointer;
            }
          }
          .image:not(:first-child) {
            margin-left: 14px;
          }
          .related-list {
            .related-item {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .name {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
              }
              .args {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
              }
            }
          }
        }
    }
  }
}
</style>